export const ALLOWED_AI_DOCUMENT_EXTENSIONS = [
  'pptx',
  'docx',
  'xlsx',
  'hwp',
  'hwpx',
  'pdf',
  'csv',
  'txt',
  'md',
];

export const ALLOWED_AI_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg'];

export const ALLOWED_AI_FILE_EXTENSIONS = [
  ...ALLOWED_AI_DOCUMENT_EXTENSIONS,
  ...ALLOWED_AI_IMAGE_EXTENSIONS,
];

export type AllowedAiFileExtension =
  (typeof ALLOWED_AI_FILE_EXTENSIONS)[number];

export const isAllowedAiImageExtension = (extension?: string) =>
  !!extension && ALLOWED_AI_IMAGE_EXTENSIONS.includes(extension.toLowerCase());

export const MIME_TYPES_MAP: Record<AllowedAiFileExtension, Array<string>> = {
  pptx: [
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ],
  docx: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  xlsx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  hwp: [
    'application/vnd.hancom.hwp',
    'application/haansofthwp',
    'application/x-hwp',
  ],
  // hwpx 는 OS/브라우저마다 MIME 을 비워 보내는 경우가 잦아 accept 의 `.hwpx` 확장자가 실질 게이트다.
  hwpx: ['application/vnd.hancom.hwpx', 'application/hwp+zip'],
  pdf: ['application/pdf'],
  csv: ['text/csv'],
  txt: ['text/plain'],
  md: ['text/markdown', 'text/x-markdown'],
  png: ['image/png'],
  jpg: ['image/jpeg'],
  jpeg: ['image/jpeg'],
};

export const AcceptAiFileExtensions = [
  ...new Set([
    ...ALLOWED_AI_FILE_EXTENSIONS.map(d => `.${d}`), // 확장자
    // MIME 타입 — jpg/jpeg 처럼 확장자가 달라도 같은 MIME 을 쓰는 쌍이 있어 중복을 제거한다.
    ...ALLOWED_AI_FILE_EXTENSIONS.flatMap(d => MIME_TYPES_MAP[d]),
  ]),
].join(', ');

export const AiFileSizeLimitMb = 30;
